// Who is in a conference call. The server stamps every list it hands out
// (live event call.conference, or the answer to add / merge / remove / mute)
// with a higher version; the two travel different ways and can arrive in
// either order, so a list older than the one shown is ignored. Pure, unit-tested.

import type { Participant } from '../api';

/** The change to make to a call for a list from the server, or null when it is older than what's shown. */
export function peopleUpdate(
  shown: { peopleVersion: number },
  participants: Participant[],
  version: number | undefined,
): { participants: Participant[]; peopleVersion: number } | null {
  const v = version ?? 0;
  if (v < shown.peopleVersion) return null;
  return { participants, peopleVersion: v };
}
